module.exports = __webpack_public_path__ + "img/feeds.caae0779.svg";